import React from "react";
import classes from "./DashboardCard.module.css";
import { Row, Col } from "react-bootstrap";
import {
  NewSignupIcon,
  // TotalBookingsIcon,
  TotalUsersIcon,
  TotalRevenueIcon,
} from "../../constant";
const DashboardCard = ({ list, icon, title }) => {
  return (
    <div className={classes.wrapper}>
      {icon}
      {/* <NewSignupIcon /> */}
      <div className={classes.cardWrapper}>
        <h2 className={classes.title}>{title  }</h2>
        <Row className={classes.cardRow}>
          {list.map((item, index) => (
            <Col md={list.length === 3 ? 4 : 5}>
              <div>
                <h3 className={classes.secondaryHeading}>{item.label}</h3>
                <div className={classes.valueWrapper}>
                  <p className={classes.value}>{item.value}</p>
                  <span className={classes.valueLabel}>{item.valueLabel}</span>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default DashboardCard;
